module.exports = __webpack_public_path__ + "img/Curso_InglesNegocios.a2f96e24.png";